export default {
	brands: "Marques",
	mystery_shopper: "Client inconnu",
	of_the_points: "des points",
	photos: "Photos",
	practice_display_and_recommend_products_with_intel_tecnology_and_you_can_redeem_the_best_prizes: "Avec Intel Rewards You, vous pouvez cumuler des points et les échanger contre des prix et des avantages incroyables! Allez!",
	processors: "Processeurs",
	product_types: "Types de produit",
	pts: "pts.",
	score: "Résultat",
	training_kpi_points: "Formation",
	trainings_kpi: "Formation KPI",
	trainings_non_kpi: "Formation non KPI"
}